import { render, staticRenderFns } from "./DealsPage.vue?vue&type=template&id=a2bb68fe&scoped=true&"
import script from "./DealsPage.vue?vue&type=script&lang=js&"
export * from "./DealsPage.vue?vue&type=script&lang=js&"
import style0 from "./DealsPage.vue?vue&type=style&index=0&id=a2bb68fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bb68fe",
  null
  
)

export default component.exports